import styled from "styled-components";

export const CnclPolicyList = styled.ul`
    position: relative;
		padding: 0 0 2.4rem 3.6rem;
		
    ::before {
      content: "";
      width: 0.4rem;
      height: 3.3rem;
      border-radius: 0.4rem;
      position: absolute;
      left: 1rem;
			top: 3rem;
			background-color: ${(p) => (p.bc ? p.bc : "")};
    }
    .policyIcon {
      display: inline-flex;
      position: absolute;
      left: 0;
      top: 0.3rem;
    }
    h5 {
      font-size: 1.4rem;
      line-height: 1.8rem;
      font-weight: 600;
      color: ${(p) => (p.theme ? p.theme?.colors?.black?.base : "#141823")};
      margin-bottom: 0.4rem;
    }
    p {
      font-size: 1.2rem;
      color: #777777;
    }

`;
